import React from "react";
import CategoryTable from "./components/Table/CategoryTable";

const Categories = () => {
    return (
        <div>
            <CategoryTable />
        </div>
    );
};

export default Categories;
